module.exports = __webpack_public_path__ + "static/fonts/notokr-light.251f03d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/amwayterms/css/fonts/notosanskr/notokr-light.woff2
// module id = oboo
// module chunks = 0